<template>
  <v-layout>
    <v-row>
      <v-col cols="12">
        <v-card class="pa-4 w-100">
          <v-card-title class="primary--text">
            My Webhooks
          </v-card-title>
          <WebhookCard v-if="loaded" title="Customer Start" :event="JobEvent.CUSTOMER_STARTED" :data="customerStartData" @submit="handleSubmit" />
          <WebhookCard v-if="loaded" title="Customer Activity Selected" :event="JobEvent.CUSTOMER_ACTIVITY_SELECTED" :data="customerActivityData" @submit="handleSubmit" />
          <WebhookCard v-if="loaded" title="Submitted" :event="JobEvent.SUBMITTED" :data="submittedData" @submit="handleSubmit" />
        </v-card>
      </v-col>
      <v-col cols="12">
        <v-card class="pa-4 w-100">
          <ListComponent
            ref="list"
            api-route="event-logs"
            favourites-key="data"
            search-field="url"
            search-field-label="Search event logs"
            :filter-options="filterOptions"
            :available-columns="availableColumns"
            :default-columns="defaultColumns"
            :actions="actions"
            :data-excel="fetchData"
            :export-name="exportName"
            type="webhook"
          />
        </v-card>
      </v-col>
    </v-row>
  </v-layout>
</template>

<script>

import axios from 'axios'
import * as Sentry from '@sentry/vue'
import ListComponent from '../../global/components/List/index.vue'
import WebhookCard from '../components/WebhookCard.vue'
import { JobEvent } from './webhooks.types.ts'
import { prettyDate as pd, prettyTime as pt } from '../../global/utils.ts'


export default {
  components: { WebhookCard, ListComponent },
  layout: 'provider',
  middleware: ['isAuthenticated'],
  data() {
    return {
      eventCode: null,
      customerStartData: ({}),
      customerActivityData: ({}),
      submittedData: ({}),
      loaded: false,
      filterOptions: [
        { text: 'Customer', key: 'eventCode', type: 'string' }
      ],
      availableColumns: [
        { text: 'Event', value: 'eventCode', display: data => this.displayEventCode(data) },
        { text: 'URL', value: 'url' },
        { text: 'Data', value: 'data', display: data => this.capText(data) },
        { text: 'Response Code', value: 'responseCode' },
        { text: 'Created', value: 'created', type: 'date', display: data => pd(data) + ' - ' + pt(data) }
      ],
      defaultColumns: ['eventId', 'url', 'data', 'responseCode', 'created'],
      actions: [
        { text: 'Resend', method: this.resendItem }
      ],
      fetchData: {
        ID: 'id',
        Event: {
          field: 'eventCode',
          callback: value => this.displayEventCode(value)
        },
        URL: 'url',
        Data: 'data',
        Response: 'responseData',
        Created: {
          field: 'created',
          callback: (value) => {
            return pd(value) + ' - ' + pt(value)
          }
        }
      },
      exportName: 'Provider - My Webhooks List.xls',
    }
  },
  computed: {
    JobEvent() {
      return JobEvent
    }
  },
  async mounted() {
    const configs = await axios.get('event-logs/config')
    for (const item of configs.data) {
      if (item.eventCode === JobEvent.CUSTOMER_STARTED) {
        this.customerStartData = item
      }
      if (item.eventCode === JobEvent.CUSTOMER_ACTIVITY_SELECTED) {
        this.customerActivityData = item
      }
      if (item.eventCode === JobEvent.SUBMITTED) {
        this.submittedData = item
      }
    }
    this.loaded = true
  },
  methods: {
    capText(text) {
      if (!text) { return text }
      return text.charAt(0).toUpperCase() + text.slice(1)
    },

    displayEventCode(text) {
      if (text === JobEvent.CUSTOMER_STARTED) {
        return 'Customer Start'
      }
      if (text === JobEvent.CUSTOMER_ACTIVITY_SELECTED) {
        return 'Customer Activity Selected'
      }
      if (text === JobEvent.SUBMITTED) {
        return 'Submitted'
      }
      return text
    },

    async resendItem(item) {
      try {
        await axios.post(`event-logs/${item.id}/resend`)
        this.$refs.list.updateResults()
      } catch (err) {
        this.$sentry.captureException(err)
        this.$store.dispatch('error', 'Unexpected error submitting item')
      }
    },

    handleSubmit(data) {
      if (data.newHook) {
        this.createWebhook(data)
      } else {
        this.updateWebhook(data)
      }
    },

    async updateWebhook(data) {
      try {
        await axios.put(`event-logs/config/${data.id}`, { url: data.url, eventCode: data.eventCode })
        this.$store.dispatch('success', 'Webhook updated')
      } catch (err) {
        Sentry.captureException(err)
        this.$store.dispatch('error', 'Unexpected error submitting item')
      }
    },
    async createWebhook(data) {
      try {
        await axios.post('event-logs/config', { url: data.url, eventCode: data.eventCode })
        this.$store.dispatch('success', 'Webhook created')
      } catch (err) {
        Sentry.captureException(err)
        this.$store.dispatch('error', 'Unexpected error submitting item')
      }
    }
  }
}

</script>
